import axios, { AxiosResponse } from 'axios';
import { getHeaders, BASE_URL } from './common';

export function parseBill(rawBill: string): Promise<AxiosResponse<string>> {
    return axios.post(BASE_URL + `/legal/bills/parse`, { body: rawBill }, {headers: getHeaders()});
}

export function createCrsUpdate(rawBill: string): Promise<AxiosResponse<string>> {
    return axios.post(BASE_URL + `/legal/bills/parse-and-apply`, { body: rawBill }, {headers: getHeaders()});
}